import React, { useContext, useEffect, useState } from 'react';
import styles from './BuildPlan.module.css';
import cn from 'classnames';
import BasicRadioBox from '../shared/Radio/BasicRadioBox';
import CategorySelect from './StepPages/CategorySelect';
import { BuildPlanContext } from '../contexts/DTC/DTCContext';
import SelectCoOp from './StepPages/SelectCoOp';
import ShopCategoryPlans from './StepPages/ShopCategoryPlans';

const GuidedDTCFlow = () => {
    const { state, dispatch } = useContext(BuildPlanContext);
    const { steps, currentStep, currentStepId, screeningAnswers } = state;

    useEffect(() => {
        dispatch({
            type: 'INIT',
            payload: {
                currentStep: steps[currentStepId]
            }
        });
    }, [currentStepId]);

    useEffect(() => {
        console.log('=== answers ===', screeningAnswers);
    }, [screeningAnswers]);

    const handleOptionClick = (e) => {
        const { value } = e.target;
        dispatch({
            type: 'ANSWER_SCREENING_QUESTION',
            payload: {
                [currentStep.questionName]: value
            }
        });
    };

    /**
     *  ======= MIGHT NEED THIS FOR ROUTING. ========
     *  SO: dispatch data, then reroute here.
     *  TRY ROUTING FROM REDUCER FIRST, AND REMOVE FUNCTIONALITY FROM HERE.
     *  IF THIS DOES NOT WORK, PULL OUT TO A HELPER IN UTIL.
     */
    const handleTraverse = (direction) => {
        dispatch({
            type: 'TRAVERSE_STEPS',
            payload: { direction }
        });
        // if (direction === 'previous' && stepId === 0) {
        //     // navigate back to home.
        //     console.log("=== NO PREVIOUS STEP. NAVIGATING HOME ===")
        //     return
        // }

        // if (direction=== 'next' && stepId === steps.length - 1) {
        //     // do some rerouting to checkout
        //     console.log("=== ALREADY ON LAST STEP. NAVIGATING TO CHECKOUT ===")
        //     return
        // }

        // if (direction === 'next' && currentStep.type === 'categorySelect' ) {
        //     dispatch({ type: 'CONFIRM_CATEGORY_SELECTION'})
        // }
    };

    if (!currentStep) return null;

    const { type, questionName } = currentStep;
    // console.log("=== currentStep ===", currentStep)
    return (
        <div>
            <div className={cn(styles.bodyWrapper, 'py-5 px-4')}>
                {type === 'question' && (
                    <>
                        <h3 className='h4'>{currentStep.questionText}</h3>
                        <div className={styles.flex}>
                            {currentStep.options?.map((o, i) => {
                                return (
                                    // <button className="btn-secondary" value={o.value}>{o.display}</button>
                                    <BasicRadioBox
                                        key={`${o.value}-${i}`}
                                        index={i}
                                        formGroupId={`question-${o.value}`}
                                        inputId={o.value}
                                        value={o.value}
                                        onChange={handleOptionClick}
                                        checked={screeningAnswers[questionName] === o.value}
                                    >
                                        {o.display}
                                    </BasicRadioBox>
                                );
                            })}
                        </div>
                    </>
                )}

                {type === 'categorySelect' && <CategorySelect />}

                {type === 'co-op' && <SelectCoOp />}

                {type === 'shopCategory' && <ShopCategoryPlans />}

                <p>step type: {type}</p>
                <button
                    onClick={() => handleTraverse('next')}
                    className='btn-primary'
                >
                    Continue
                </button>
            </div>
        </div>
    );
};

export default GuidedDTCFlow;
